export default {
  placeholder: 'Select severity levels',
};
